import { Box } from "@mui/system";
import GenericFilterBox from "../common/GenericFilterBox";
import { useForm } from "react-hook-form";
import FormInput from "../common/FormInput";
import useTenant from "../../hooks/useTenant";
import { nameof } from "../common/ObjectUtils";
import { DriversTypes } from "../drivers/Types";
import * as MuiIcons from "@mui/icons-material";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { DamageTypes } from "../damageListCrud/Types";
import Switch from "@mui/material/Switch";
import { useContext, useEffect, useRef, useState } from "react";
import { VehicleToBeRepairedService } from "./service/veficleToBe.active";
import { ContextOperation } from "../../context/OperationContext";
import { AutoCompleteOption } from "../common/AutoComplete";
import { values } from "underscore";
import { useAgGridCustomDatasource } from "../../hooks/useAgGridCustomDatasource";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { StatusTypes } from "./Type";
import { saveFileFromResponse } from "../../utils";
import useSnackbar from "../../hooks/useSnackbar";
import Chip from "@mui/material/Chip/Chip";
import VehicleRepairedDetails from "./VehicleRepairedDetails";
import useToggle from "../../hooks/useToggle";
import {useTranslation} from "react-i18next";
import AgGridOperationTable from "../common/AgGridOperationTable";

export const VehicleToBeRepairedTable = () => {
  
  const t = useOperationTranslation();
  const { tenantOptions: options } = useTenant();
  const [checked, setChecked] = useState<boolean>(true);
  const [status, setStatus] = useState<AutoCompleteOption[]>([]);
  const [selectVehicle, setSelectVehicle] = useState<any>([]);
  const { tenant } = useContext(ContextOperation);
  const { setLoading } = useContext(ContextOperation);
  const snackbar = useSnackbar();
  const [showVehicleDetails, toggleVehicleDetails] = useToggle();
  const form = useForm<StatusTypes.StatusSearch>({
    defaultValues: {
           open:true
    },
  });
  const {i18n} = useTranslation();
  const [
    damagePriceListDataSource,
    totalmissingEquipment,
    updateDatasourceDamage,
  ] = useAgGridCustomDatasource(
    VehicleToBeRepairedService.get.getStatausList,
    [tenant, form.getValues()],
    [tenant, form.formState.submitCount]
  );

  const onReset =()=>{


    form.reset();
    form.setValue('open',true);
    setChecked(true);
  }

  const toggleChecked = () => {

    form.setValue("open", !checked);
    setChecked((prev) => !prev);
  };
  const isDisabled = () => {
    if (Object.keys(form?.getValues).length !== 1 || options.length > 1) {
      return Object.values(form?.getValues()).every(
        (x) => x === null || x === undefined || x === ""
      );
    }
    return true;
  };

  const setStatusLabel = (status : any) => {

     if (status === "MARKED_TO_BE_REPAIRED")
      return t("vehicleToBeRepaired.status.marked_to_be_repaired");    
    else if (status === "WORKSHOP_ENGAGEMENT")
      return t("vehicleToBeRepaired.status.workshop_engagement");
    else if (status === "TRANSFER_FOR_WORKSHOP")
      return t("vehicleToBeRepaired.status.transfer_for_workshop");
    else if (status === "ARRIVED_IN_REPAIR_SHOP")
      return t("vehicleToBeRepaired.status.arrived_in_repair_shop");
    else if (status === "QUOTE_RECEIVED")
      return t("vehicleToBeRepaired.status.quote_received");
    else if (status === "QUOTE_DENIED")
      return t("vehicleToBeRepaired.status.quote_denied");
    else if (status === "QUOTE_APPROVED")
      return t("vehicleToBeRepaired.status.quote_approved");
    else if (status === "SPARE_PARTS_ORDERED")
      return t("vehicleToBeRepaired.status.spare_parts_ordered");
    else if (status === "SPARE_PARTS_UNAVAILABLE")
      return t("vehicleToBeRepaired.status.spare_parts_unavailable ");
    else if (status === "SPARE_PARTS_RECEIVED")
      return t("vehicleToBeRepaired.status.spare_parts_received ");
    else if (status === "WORK_STARTED")
      return t("vehicleToBeRepaired.status.work_started");
    else if (status === "WORK_ENDED")
      return t("vehicleToBeRepaired.status.work_ended");
    else if (status === "RETURNED")
      return t("vehicleToBeRepaired.status.returned");
    else
      return status;
    
  }

  i18n.on('languageChanged', () => {
    getAllStatus();
  });

  const getAllStatus = () => {
    VehicleToBeRepairedService.get.getStatus(tenant).then((response) => {
      let result = Object.entries(response).map(([k, v]) => ({ [k]: v }));
      setStatus(
        result.map((eqp: any) => ({
          value: `${Object.keys(eqp)}`,
          label: setStatusLabel(`${Object.keys(eqp)}`),
        }))
      );
    });
  };
  useEffect(() => {
    getAllStatus();
  }, [tenant]);

  const OpenVehicleDetails = (vehicle: any) => {
    setSelectVehicle(vehicle);
    toggleVehicleDetails();
  };

  const onSubmit = () => { };
  const handleDownloadTemplate = () => {
    setLoading(true);
    VehicleToBeRepairedService.get
      .export(tenant, form.getValues())
      .then((response) => {
        saveFileFromResponse(response);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        snackbar.show("error", t("missingEquipment.errors.actionError"));
      });
  };
  const equipmentColumns: ColDef[] = [
    {
      field: nameof<StatusTypes.StatusList>("formProgressive"),
      headerName: t("vehicleToBeRepaired.fields.damageForm"),
      sortable: true,
      flex: 1,
    },
    {
      field: nameof<StatusTypes.StatusList>("plate"),
      headerName: t("vehicleToBeRepaired.fields.plate"),
      sortable: true,
      flex: 1,
    },

    {
      field: nameof<StatusTypes.StatusList>("status"),
      headerName: t("vehicleToBeRepaired.fields.status"),
      flex: 1,
      cellRenderer: (props: ICellRendererParams<StatusTypes.StatusList>) => {
        return (
          <Chip
            variant="filled"
            color="success"
            label={setStatusLabel(props.data?.statusCode)}
          ></Chip>
        );
      },
    },

    {
      field:"_actions",
      maxWidth: 100,
      minWidth: 100,
      headerName:"",
      cellRenderer: (props: ICellRendererParams<DriversTypes.Drivers>) => {
        return (
          <Tooltip title={t("tooltipTitle.vehicleHistory")}>
            <Button variant="text" size="icon" color="accent">
              <MuiIcons.Description onClick={() => OpenVehicleDetails(props)} />
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Box>
      <>
        <form
          id="equipment-kit-tab-search-form"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <GenericFilterBox
            formId="equipment-kit-tab-search-form"
            disableResetButton={isDisabled()}
            onReset={() => {
              onReset();
            }}
          >
            <FormInput
              type="select"
              options={status}
              label={t("vehicleToBeRepaired.fields.status")}
              name={nameof<StatusTypes.StatusSearch>("status")}
              value={form.watch("status")}
              onChange={(value) => {
                form.setValue(nameof<StatusTypes.StatusSearch>("status"), value);
              }}
              fullWidth
            />

            <FormInput
              type="text"
              label={t("vehicleToBeRepaired.fields.plate")}
              name={nameof<StatusTypes.StatusSearch>("plate")}
              formInstance={form}              
              fullWidth
            />
          </GenericFilterBox>
        </form>
      </>
      <Card>
        <CardContent>
          <Box
            sx={{
              backgroundColor: "white",
              border: " 1px solid #dbe4e9",
              borderRadius: "2px",
              padding: "9px 1px 3px 2px",
            }}
          >
            <Grid
              container
              spacing={2}
              alignItems="center"
              alignContent="center"
              direction="row"
            >
              <Grid item xs={6}></Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    justifyContent: "flex-end",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <Stack direction="row" alignItems="center">
                    <FormGroup>
                      <FormControlLabel
                        name={nameof<DamageTypes.FilterDamage>("open")}
                        control={
                          <Switch
                            sx={{ margin: 1 }}
                             checked ={checked}
                            color="default"
                             onChange={toggleChecked}
                          />
                        }
                        label={t("vehicleToBeRepaired.fields.open")}
                      />
                    </FormGroup>
                    <Button
                      variant="text"
                      size="icon"
                      disabled={totalmissingEquipment ? false : true}
                      onClick={handleDownloadTemplate}
                      color="accent"
                    >
                      <Tooltip title={t("tooltipTitle.download")}>
                        <FileDownloadIcon />
                      </Tooltip>
                    </Button>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Grid>
            <Grid item sx={{ whiteSpace: "pre-wrap" }}>
              <AgGridOperationTable
                rowStyle={{ width: "250%" }}
                columnDefs={equipmentColumns}
                serverSideDatasource={damagePriceListDataSource}
                rowModelType="serverSide"
                serverSideInfiniteScroll={true}
                cacheBlockSize={10}
                rowSelection="single"
                totalElements={totalmissingEquipment}
                emptyState={{
                  title:t("vehicleToBeRepaired.noData.title"),
                  content:t("vehicleToBeRepaired.noData.body")
                }}
              />

            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <VehicleRepairedDetails
        tenant={tenant}
        open={showVehicleDetails}
        onClose={toggleVehicleDetails}
        kit={selectVehicle}
      />
    </Box>
  );
};
